import { render, staticRenderFns } from "./EditarMensajeModal.vue?vue&type=template&id=f7186368&"
import script from "./EditarMensajeModal.vue?vue&type=script&lang=ts&"
export * from "./EditarMensajeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f7186368', component.options)
    } else {
      api.reload('f7186368', component.options)
    }
    module.hot.accept("./EditarMensajeModal.vue?vue&type=template&id=f7186368&", function () {
      api.rerender('f7186368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Mensaje/EditarMensajeModal.vue"
export default component.exports